<template>
    <div class="step">
        <div class="step__container">

            <div class="step__title" ref="title">
                <p>Please make your Ohana account.</p>
            </div>

            <form class="step__form" ref="form">

                <!-- Name -->
                <InputField
                    title="FULL NAME"
                    type="name"
                    placeholder="First Last"
                    autocomplete="name"
                    autocapitalize="words"
                    v-model="name"
                    :disabled="false"
                    :errored="false"
                    :validated="nameValid"
                    errorMessage=""
                ></InputField>

                <!-- Email -->
                <InputField
                    title="EMAIL"
                    type="email"
                    placeholder="email@hello.com"
                    autocomplete="email"
                    autocapitalize="off"
                    v-model="email"
                    :disabled="false"
                    :errored="false"
                    :validated="emailValid"
                    :errorMessage="emailErrorMessage"
                ></InputField>

                <!-- Password -->
                <InputField
                    title="PASSWORD"
                    type="password"
                    placeholder="password"
                    v-model="password"
                    :disabled="false"
                    errorMessage=""
                    :validated="passwordValid"
                ></InputField>
                

                <!-- Privacy Policy & TOS -->
                <br>
                <div class="step__form-links">
                    <p>By creating an account you agree to our <br>
                        <a href="https://ohanaisfamily.com/privacy-policy.html" target="_blank">Privacy Policy</a> and <a href="https://ohanaisfamily.com/terms-and-conditions.html" target="_blank">Terms of Use.</a></p>
                </div>

            </form>

            <!-- Create Account Button -->
            <div class="step__button" ref="button">
                <a href="#" @click.prevent="goNextStep" class="button" :class="{'button--disable': (!isValid())}">
                    <span>Create Account</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

    import InputField from "@/components/1-common/InputField";

    import checkIcon from '@/assets/svg/check.svg';
    import errorCheckIcon from '@/assets/svg/error-check.svg';
    import checkWhiteIcon from '@/assets/svg/check-white.svg';
    import checkLockIcon from '@/assets/svg/lock.svg';
    import { TimelineMax } from 'gsap';

    import { auth, usersCollection } from '../../tools/firebaseConfig';
    import { setTimeout } from 'timers';
    const fb = require('../../tools/firebaseConfig.js');

    let tl = new TimelineMax({
        delay: 1
    });

    export default {
        name: 'Step2_MakeAcc',
        data() {
            return {
                name: '',
                email: '',
                password: '',
                emailErrorMessage: '',
                invalidEmail: ''
            }
        },
        watch: {
            name: function (val) {
                // console.log(val);
                const data = {
                    field: 'full_name',
                    new_value: val
                }
                amplitude.getInstance().logEvent('input_changed', data);
            },
            email: function (val) {
                // console.log(val);
                const data = {
                    field: 'email',
                    new_value: val
                }
                amplitude.getInstance().logEvent('input_changed', data);
            }
        },
        components: {
            InputField,

            checkIcon,
            errorCheckIcon,
            checkWhiteIcon,
            checkLockIcon
        },
        computed: {
            nameValid: function () {
                return this.name.length >= 2;
            },
            emailValid: function () {
                if (this.email == this.invalidEmail) { return false; }
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
            },
            passwordValid: function () {
                return this.password.length >= 6;
            },
        },
        methods: {
            isValid() {

                return this.nameValid && this.emailValid && this.passwordValid
            },
            persist() {
                localStorage.setItem('name', this.name);
                localStorage.setItem('email', this.email);
                localStorage.setItem('passwordLength', this.password.length);
                localStorage.setItem('accountCreated', true);
            },
            goNextStep() {

                if (!this.isValid()) { return; }
                
                this.persist()

                this.$emit('showLoading');
                console.log('creating user...');

                auth.createUserWithEmailAndPassword(this.email, this.password)
                .then(credential => {
                    
                    console.log('user auth created!');
                    console.log('credential:');
                    console.log(credential);

                    let uid = credential.user.uid;
                    let email = credential.user.email

                    const userModel = {
                        'email': email,
                        'emergencyNumber': '911',
                        'name': this.name,
                        'profileImageUrl': 'https://firebasestorage.googleapis.com/v0/b/ohana-4dd34.appspot.com/o/UserImages%2F88n3CkBsoiXdU8E5LYPi1s1tT6d2%2FprofilePicture?alt=media&token=a32567f2-9e2d-4e93-8ed1-d49a43f01859',
                        'uid': uid,
                        'signup_platform': 'web'
                    }

                    console.log('creating Database entry...');

                    usersCollection.child(uid).set(userModel)
                    .then(() => {
                        console.log('user created in DB!');
                        this.$parent.currentName = this.name;
                        this.$parent.currentUid = uid;
                        this.$parent.currentEmail = this.email;
                        this.$emit('dismissLoading');
                        this.$emit('nextStep');
                    })
                    .catch(error => {
                        console.log('error creating user in DB:');
                        console.log(error);
                    })

                    // Update display name
                    credential.user.updateProfile({
                        displayName: this.name
                    })
                    .then(() => {
                        console.log('displayName updated');
                    })
                    .catch(error => {
                        console.log('error updating Profile:');
                        console.log(error);
                    })

                    // Send Amplitude User credential update
                    const userProperties = {
                        email: email,
                        firebase_uid: uid,
                        name: this.name,
                        sign_up_date: new Date()
                    };

                    amplitude.getInstance().setUserId(uid);
                    amplitude.getInstance().setUserProperties(userProperties);

                    // Facebook Pixel

                    // Advanced
                    fbq('init', '1147144752146644', {
                        em: email
                    });

                    // Standard
                    fbq('track', 'CompleteRegistration');

                })
                .catch(error => {

                    this.$emit('dismissLoading');

                    console.error('createUserWithEmailAndPassword error:');
                    console.log(error);
                    if (error.code == 'auth/email-already-in-use') {
                        this.emailErrorMessage = error.message;
                        this.invalidEmail = this.email;
                    } else {
                        console.log('UNACCOUNTED FOR CODE!:');
                        console.log(error.code);
                        
                    }
                })
            }
        },
        mounted() {
            // console.log('two loaded');
            amplitude.getInstance().logEvent('signup_page_createaccount_loaded');

            // Persistance
            // if (localStorage.name) {
            //     this.name = localStorage.name;
            // }

            // if (localStorage.email) {
            //     this.email = localStorage.email;
            // }

            // if (localStorage.passwordLength) {
            //     this.password = "a".repeat(localStorage.passwordLength);
            // }

            // if (localStorage.accountCreated) {
            //     this.nextButtonText = 'Next';
            // }

            // Animations
            const {title, subtitle, check, form, button} = this.$refs;
            tl
            .from([title, subtitle], 1.2, {autoAlpha: 0, ease: Power2.easeOut})
            .from(form, 1.2, {autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
            .from(button, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
        }
    }
</script>




// WEBPACK FOOTER //
// Step2_MakeAcc.vue?1388a2ed